import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { Chapter, Class, Loan, LoanWithDecomposition } from "../../../model";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Handsontable from "handsontable";
import { requireValidation } from "../../../domain/sfp/loan-domain";
import { formatDeleveragingYears } from '../../../domain/sfp/cash-flow-domain';

export function durationRenderer(
	hot,
	td: HTMLTableCellElement,
	row: number,
	col: number,
	prop: string,
	value: number,
	cellProperties: {}
): void {
	const formattedDuration = formatDeleveragingYears(value)
	const args = [hot, td, row, col, prop, formattedDuration, cellProperties]
	Handsontable.renderers.TextRenderer.apply(this, args)
}

export function instructionChapterRenderer(
	hot,
	td: HTMLTableCellElement,
	row: number,
	col: number,
	prop: string,
	chapter: Chapter,
	cellProperties: {}
): void {
	const chapterLabel = getChapterLabel(chapter)
	const args = [hot, td, row, col, prop, chapterLabel, cellProperties]
	Handsontable.renderers.TextRenderer.apply(this, args)
}

export function instructionClassRenderer(
	hot,
	td: HTMLTableCellElement,
	row: number,
	col: number,
	prop: string,
	instructionClass: Class,
	cellProperties: {}
): void {
	const chapterLabel = getClassLabel(instructionClass)
	const args = [hot, td, row, col, prop, chapterLabel, cellProperties]
	Handsontable.renderers.TextRenderer.apply(this, args)
}

export function fontAwesomeRenderer(
	instance,
	td: HTMLTableCellElement,
	row,
	col,
	prop: string,
	loanWithDecomp: LoanWithDecomposition,
	cellProperties: {}
): void {
	Handsontable.renderers.TextRenderer.apply(this, arguments);
	null != loanWithDecomp && null != loanWithDecomp && loanWithDecomp.loan.simulate && requireValidation(loanWithDecomp) ? ReactDOM.render(<FontAwesomeIcon icon="exclamation-triangle" color="#ffdd57" style={{marginLeft: "10px"}} />, td) : ReactDOM.render(<span></span>, td)
}

export function linkRenderer(
	instance,
	td: HTMLTableCellElement,
	row,
	col,
	prop: string,
	link: string,
	cellProperties: {},
	name: string,
	show: string,
	data:any,
	loan:any
): void {
	Handsontable.renderers.TextRenderer.apply(this, arguments)
	if (link === "Total") {
		 ReactDOM.render(<span style={{ fontWeight: "bold"}}>{link}</span>, td)
	} else if(!loan.simulate && !loan.detteRecuperable ){
		ReactDOM.render(<a href={link} style={{ color: "#B2CB3B"}}>{name}</a>, td)
	}else if(!loan.simulate && loan.detteRecuperable ){
		ReactDOM.render(<a href={link} style={{ color: "#5F8949"}}>{name}</a>, td)
	}else if(loan.simulate && !loan.detteRecuperable){
		ReactDOM.render(<a href={link} style={{ color: "#BB2307"}}>{name}</a>, td)
	}else if(loan.simulate && loan.detteRecuperable){
		ReactDOM.render(<a href={link} style={{ color: "#F05B06"}}>{name}</a>, td)
	}
	if(row == data.length - 7){
		if(link === 'Dette normale' && show == 'num'){
			ReactDOM.render(<span style={{ fontWeight: "bold",color: "white"}}>{link}</span>, td)
			td.style.backgroundColor = "#B2CB3B";
		}
		td.style.backgroundColor = "#B2CB3B";
	} else if(row == data.length - 6){
		if(link === 'Dette normale récupérable' && show == 'num'){
		ReactDOM.render(<span style={{ fontWeight: "bold",color: "white"}}>{link}</span>, td)
		td.style.backgroundColor = "#5F8949";
	}
	    td.style.backgroundColor = "#5F8949";
    }else if(row == data.length - 5){
		if(link === 'Total Dette' && show == 'num'){
		ReactDOM.render(<span style={{ fontWeight: "bold",color: "white"}}>{link}</span>, td)
		td.style.backgroundColor = "lightGray";
	}
	    td.style.backgroundColor = "lightGray";
    }else if(row == data.length - 2){
		if(link === 'Total dette simulée' && show == 'num'){
		ReactDOM.render(<span style={{ fontWeight: "bold",color: "white"}}>{link}</span>, td)
		td.style.backgroundColor = "lightGray";
	}
	td.style.backgroundColor = "lightGray";
	}else if(row == data.length - 4){
		if(link === 'Dette simulée' && show == 'num'){
		ReactDOM.render(<span style={{ fontWeight: "bold",color: "white"}}>{link}</span>, td)
		td.style.backgroundColor = "#BB2307";
	}
	td.style.backgroundColor = "#BB2307";
	}else if(row == data.length - 3){
		if(link === 'Dette simulée récupérable' && show == 'num'){
		ReactDOM.render(<span style={{ fontWeight: "bold",color: "white"}}>{link}</span>, td)
		td.style.backgroundColor = "#F05B06";
	}
	    td.style.backgroundColor = "#F05B06";
	}
}

function getChapterLabel(ch: Chapter): string {
	return ch ? `${ch.number} - ${ch.label}` : "Aucun"
}

function getClassLabel(cl: Class): string {
	return cl ? `${cl.number} - ${cl.label}` : "Aucune"
}



// WEBPACK FOOTER //
// ./src/component/utils/handsontable/renderers.tsx